import(/* webpackMode: "eager", webpackExports: ["CollaborationMadeEasy"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/collaboration-made-easy.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/feature-teams.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/feature-header/feature-header.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["FlexibleViews"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/flexible-views/flexible-views.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganisePrioritise"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/organise-prioritise.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/prefooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewsGrid"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/reviews-grid/reviews-grid.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/reviews-section/nyt.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/reviews-section/reviews-section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SeeProgress"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/see-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedOfThought"] */ "/app/apps/todoist-landing-pages/app/[locale]/features/components/speed-of-thought.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppsSection"] */ "/app/apps/todoist-landing-pages/components/apps-section/apps-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/award/award.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["GetStartedButtonSimple"] */ "/app/apps/todoist-landing-pages/components/Get-Started-Button/Get-Started-Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainPageHeader"] */ "/app/apps/todoist-landing-pages/components/main-page-header/main-page-header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/SectionHeader/SectionHeader.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/public/static/award/leaf.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/packages/marketist/dist/components/Button/Button.js");
;
import(/* webpackMode: "eager" */ "/app/packages/marketist/dist/components/image/image.js");
